import { render } from "./AgeDistributionChart.vue?vue&type=template&id=b15e51aa&scoped=true"
import script from "./AgeDistributionChart.vue?vue&type=script&lang=js"
export * from "./AgeDistributionChart.vue?vue&type=script&lang=js"

import "./AgeDistributionChart.vue?vue&type=style&index=0&id=b15e51aa&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15e51aa"],['__file',"src/components/AgeDistributionChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b15e51aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b15e51aa', __exports__)) {
    console.log('reload')
    api.reload('b15e51aa', __exports__)
  }
  
  module.hot.accept("./AgeDistributionChart.vue?vue&type=template&id=b15e51aa&scoped=true", () => {
    console.log('re-render')
    api.rerender('b15e51aa', render)
  })

}


export default __exports__